import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { UserService } from '@eadsysteme/ewsauthclient-v1';
import { Icons } from '../../../util/Icons';
import { SnackbarService } from '../../../services/snackbar.service';
import { KeycloakService } from 'src/app/auth/keycloak.service';
import { MatDialog } from '@angular/material/dialog';
import { LogoutService } from '../../../../@vex/services/logout.service';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'vex-delete-profile',
	templateUrl: './delete-profile.component.html',
	styleUrl: './delete-profile.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, MatButton, MatIcon],
})
export class DeleteProfileComponent {
	translocoService = inject(TranslocoService);
	userService = inject(UserService);
	icons = inject(Icons);
	snackbar = inject(SnackbarService);
	keycloak = inject(KeycloakService);
	private logoutService = inject(LogoutService);
	private dialog = inject(MatDialog);

	confirmDeleteUser() {
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			disableClose: false,
			autoFocus: false,
			restoreFocus: false,
		});
		dialogRef.componentInstance.titleMessage = this.translocoService.translate('errors.warning');
		dialogRef.componentInstance.confirmMessage = this.translocoService.translate('userProfile.confirmDeleteUser');

		dialogRef.afterClosed().subscribe((val) => {
			if (val) {
				this.deleteUser();
			}
		});
	}

	deleteUser() {
		const userId = this.keycloak.getKeycloakInstance().tokenParsed.sub;
		this.userService.deleteOwnUser(userId).subscribe({
			next: (response) => {
				if (response) {
					this.notifyUserAndLogout();
				} else this.snackbar.error(this.translocoService.translate('userProfile.deleteUserBadInput'));
			},
			error: () => {
				this.snackbar.error(this.translocoService.translate('errors.userProfileDeleteUser'));
			},
		});
	}

	notifyUserAndLogout() {
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			disableClose: false,
			autoFocus: false,
			restoreFocus: false,
		});
		dialogRef.componentInstance.showCloseButton = false;
		dialogRef.componentInstance.confirmMessage = this.translocoService.translate('userProfile.deleteUserSuccess');
		dialogRef.componentInstance.confirmButtonText = this.translocoService.translate('common.ok');

		dialogRef.afterClosed().subscribe(() => {
			this.logoutService.logout();
		});
	}
}
